import { CommissionReceiptsRequestInterface } from '../../../interfaces/request/commission-receipts/commission-receipts-request-interface';

export class CommissionReceiptsRequestModel implements CommissionReceiptsRequestInterface {
  billedDateEnd: string = '';
  billedDateStart: string = '';
  name: string = '';
  page: number | undefined;
  pageSize: number | undefined;
  policyNumber: string = '';
  receiptNumber: string = '';

  constructor(init?: Partial<CommissionReceiptsRequestModel>) {
    Object.assign(this, init);
  }
}
